import { Button, Tooltip } from "@mui/material";

type WasteStreamBulkActionsProps = {
  selectedCount: number;
  showCreateSubmissions: boolean;
  /** How many selected streams need a new registration submission. */
  submittableCount: number;
  onManageTags: () => void;
  onCreateSubmissions: () => void;
};

/**
 * Staff actions on the streams selected in the Waste Streams grid. Create
 * submissions acts on the selected streams that need one and skips the rest.
 */
export function WasteStreamBulkActions({
  selectedCount,
  showCreateSubmissions,
  submittableCount,
  onManageTags,
  onCreateSubmissions,
}: WasteStreamBulkActionsProps) {
  const skipsSome = submittableCount > 0 && submittableCount < selectedCount;
  return (
    <>
      <Button variant="outlined" size="small" disabled={selectedCount === 0} onClick={onManageTags}>
        {`Manage tags (${selectedCount})`}
      </Button>
      {showCreateSubmissions && (
        <Tooltip
          title={
            skipsSome ? "Only streams that need a new registration submission are included" : ""
          }
        >
          <span>
            <Button
              variant="outlined"
              size="small"
              disabled={submittableCount === 0}
              onClick={onCreateSubmissions}
            >
              {skipsSome
                ? `Create submissions (${submittableCount} of ${selectedCount})`
                : `Create submissions (${submittableCount})`}
            </Button>
          </span>
        </Tooltip>
      )}
    </>
  );
}
